module.exports = __webpack_public_path__ + "assets/img/5_1203.f1b08c39.jpg";